export const sendRequest = async (requestObj) => {
    try {
        return await requestObj;
    } catch (err) {
        return err;
    }
}